(() => {
  const syncControl = (control) => {
    const consentId = control.dataset.dotConsentId;
    const checkbox = consentId ? document.getElementById(consentId) : null;

    if (!checkbox) return;

    const container = checkbox.closest('[data-dot-wedding-consent]');
    const requiredCheckboxes = Array.from(container?.querySelectorAll('[data-dot-consent-checkbox]') || []);
    const allChecked = requiredCheckboxes.length > 0 && requiredCheckboxes.every((item) => item.checked);
    const quantityValid = control.dataset.dotQuantityValid !== 'false';
    const canContinue = allChecked && quantityValid;

    control.disabled = !canContinue;
    control.setAttribute('aria-disabled', canContinue ? 'false' : 'true');
  };

  const syncAll = (root = document) => {
    root.querySelectorAll('[data-dot-requires-consent]').forEach(syncControl);
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-dot-consent-checkbox]')) return;

    const container = event.target.closest('[data-dot-wedding-consent]');
    const error = container?.querySelector('[data-dot-consent-error]');
    const allChecked = Array.from(container?.querySelectorAll('[data-dot-consent-checkbox]') || []).every(
      (checkbox) => checkbox.checked
    );
    if (error) error.hidden = allChecked;
    syncAll();
  });

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-dot-requires-consent]');
    if (!control) return;

    const checkbox = document.getElementById(control.dataset.dotConsentId);
    const container = checkbox?.closest('[data-dot-wedding-consent]');
    const unchecked = Array.from(container?.querySelectorAll('[data-dot-consent-checkbox]') || []).find(
      (item) => !item.checked
    );
    const quantityValid = control.dataset.dotQuantityValid !== 'false';
    if (!unchecked && quantityValid) return;

    event.preventDefault();
    const error = container?.querySelector('[data-dot-consent-error]');
    if (error && unchecked) error.hidden = false;
    unchecked?.focus();
  });

  const observer = new MutationObserver(() => syncAll());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAll(), { once: true });
  } else {
    syncAll();
  }
})();
